import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { experimentalStyled } from '@mui/material';
import AppNavbar from './AppNavbar';
import AppSidebar from './AppSidebar';
import MobileFooter from './MobileFooter';

const OwnerLayoutRoot = experimentalStyled('div')(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  })
);

const OwnerLayoutWrapper = experimentalStyled('div')(
  ({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 275
    },
    [theme.breakpoints.down('lg')]: {
      paddingBottom: 56 // Add padding for mobile footer
    }
  })
);

const OwnerLayoutContainer = experimentalStyled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden'
});

const OwnerLayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto'
});

const OwnerLayout = () => {
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <OwnerLayoutRoot>
      <AppNavbar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <AppSidebar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <OwnerLayoutWrapper>
        <OwnerLayoutContainer>
          <OwnerLayoutContent>
            <Outlet />
          </OwnerLayoutContent>
        </OwnerLayoutContainer>
      </OwnerLayoutWrapper>
      <MobileFooter />
    </OwnerLayoutRoot>
  );
};

export default OwnerLayout;
